import * as prismic from '@prismicio/client';
import { enableAutoPreviews } from '@prismicio/next';
import sm from './sm.json';

const endpoint = sm.apiEndpoint;

// Update the Link Resolver to match your project's route structure
export function linkResolver(doc) {
  switch (doc.type) {
    case 'blog_page':
      return `/blog/${doc.uid}`;
    case 'landing_page':
      return `/${doc.uid}`;
    case 'blog_profile':
      return `/blog/author/${doc.uid}`;
    default:
      return '';
  }
}

// This factory function allows smooth preview setup
export function createClient(config = {}) {
  const client = prismic.createClient(endpoint, {
    ...config,
  });

  enableAutoPreviews({
    client,
    previewData: config.previewData,
    req: config.req,
  });

  return client;
}
